export default __webpack_public_path__ + "static/media/Group8865.c062e78d.svg";